import type { SlideProps } from "@/engine/app/offsite-config";
import { OutputCarousel } from "@/workshop/OutputCarousel";

/**
 * Abschluss der Session. Der Rahmen bleibt bewusst zurückhaltend — das
 * Auffälligste auf der Leinwand ist der Prototyp, nicht unsere Überschrift.
 * Keine Reihenfolge, keine Bewertung, keine Sieger.
 */
export function Slide04Reveal(_: SlideProps) {
  return (
    <div className="deck-root ar-slide" style={{ background: "var(--ink-900)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--ink-400)" }}>
          Ergebnis
        </div>
        <h1 className="deck-title rise rise-2">Was daraus entstanden ist</h1>
      </header>

      <div className="ar-reveal-stage rise rise-3">
        <OutputCarousel phase="reveal" />
      </div>
    </div>
  );
}
